// extracted by mini-css-extract-plugin
module.exports = {"contents":"if","sectionHeading":"jf"};